import React from "react";
import { useTranslation } from "react-i18next";

const AlertMessage = ({ alert, onClose }) => {
  const { t } = useTranslation();
  if (!alert) return null;

  return (
    <div
      className={`w-full px-4 py-3 mb-4 rounded-md text-sm flex items-center shadow-sm transition-all duration-300 ease-in-out ${
        alert.type === "error"
          ? "bg-red-50 text-red-800"
          : "bg-green-50 text-green-800"
      }`}
      role="alert"
    >
      {/* Icon */}
      <div className="flex-shrink-0 mr-3">
        {alert.type === "error" ? (
          <svg className="h-5 w-5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        ) : (
          <svg className="h-5 w-5 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        )}
      </div>
    
      {/* Content */}
      <div className="flex-1 font-medium leading-tight">
        {alert.message}
      </div>
    
      {/* Close button */}
      <button
        onClick={onClose}
        className="flex-shrink-0 ml-auto -mr-1 text-gray-400 hover:text-gray-600 focus:outline-none"
        aria-label={t("alert_message.close_button_aria")}
      >
        <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
};

export default AlertMessage;
